import Layout from '@/layout/index.vue'
import SYSTEM_ROUTE from '@/router/system'
import SUPPLIER_ROUTE from '@/router/supplier'
import TOOLS_ROUTE from '@/router/tools'
import RPA_ROUTE from '@/router/rpa'
import LOGISTICS_ROUTE from '@/router/logistics'
import FIRST_LEG_DELIVERY_ROUTES from '@/router/first-leg-delivery'
import MULTI_PLATFORM_ROUTES from '@/router/multi-platform'
import BASE_DATA_ROUTE from '@/router/base-data'
import PRODUCT_MANAGEMENT from '@/router/product-management'
import OA_ROUTE from '@/router/oa'
import AI_ROUTE from '@/router/ai'
import PRODUCT_OPERATION from '@/router/product-operation'

export default [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    meta: { title: '首页', affix: true, icon: 'home-4-line', keepAlive: true },
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/views/index'),
        meta: {
          title: '首页',
          icon: 'home-4-line',
          keepAlive: true,
        },
      },
      {
        path: '/system/organization',
        name: 'Organization',
        component: () => import('@/views/system/organization'),
        meta: {
          title: '组织架构',
          icon: 'bar-chart-line',
          keepAlive: true,
        },
      },
      {
        path: '/system/menu',
        name: 'Menu',
        component: () => import('@/views/system/menu'),
        meta: {
          title: '菜单管理',
          icon: 'menu-line',
          keepAlive: true,
        },
      },
      {
        path: '/system/role',
        name: 'Role',
        component: () => import('@/views/system/role'),
        meta: {
          title: '角色管理',
          icon: 'user-line',
          keepAlive: true,
        },
      },
      {
        path: '/system/user',
        name: 'UserList',
        component: () => import('@/views/system/user'),
        meta: {
          title: '用户管理',
          icon: 'user-add-line',
          keepAlive: true,
        },
      },
      {
        path: 'system/organization',
        name: 'Organization',
        component: () => import('@/views/system/organization'),
        meta: {
          title: '组织架构管理',
          icon: 'ordered-list-line',
          keepAlive: true,
        },
      },
      {
        path: 'system/dataRate',
        name: 'DataRate',
        component: () => import('@/views/system/dataRate'),
        meta: {
          title: '汇率列表',
          icon: 'sort-line',
          keepAlive: true,
        },
      },
      {
        path: 'system/teamManagement',
        name: 'TeamManagement',
        component: () => import('@/views/system/teamManagement'),
        meta: {
          title: '项目组',
          icon: 'bookmark-line',
          keepAlive: true,
        },
      },
      {
        path: 'basic/storeCaptcha',
        name: 'storeCaptcha',
        component: () => import('@/views/basic/storeManagement'),
        meta: {
          title: '店铺管理',
          icon: 'remixicon-line',
          keepAlive: true,
        },
      },
      {
        path: 'basic/inventory',
        name: 'Inventory',
        component: () => import('@/views/basic/inventory'),
        meta: {
          title: '库存绩效',
          icon: 'remixicon-line',
          keepAlive: true,
        },
      },
      {
        path: 'basic/productManage',
        name: 'ProductManage',
        component: () => import('@/views/basic/productManage/'),
        meta: {
          title: '产品列表',
          icon: 'remixicon-line',
          keepAlive: true,
        },
      },
      {
        path: 'basic/productManage/detail',
        name: 'ProductManageDetail',
        component: () => import('@/views/basic/productManage/detail'),
        meta: {
          title: '产品详情',
          icon: 'remixicon-line',
          keepAlive: false,
        },
      },
      {
        path: 'basic/productLicensing',
        name: 'ProductLicensing',
        component: () => import('@/views/basic/productLicensing'),
        meta: {
          title: '产品授权',
          icon: 'remixicon-line',
          keepAlive: true,
        },
      },
      {
        path: 'basic/projectManagement',
        name: 'ProjectManagement',
        component: () => import('@/views/basic/projectManagement'),
        meta: {
          title: '项目管理',
          icon: 'remixicon-line',
          keepAlive: true,
        },
      },
      {
        path: 'basic/listing',
        name: 'Listing',
        component: () => import('@/views/basic/listing/index'),
        meta: {
          title: 'Listing',
          icon: 'remixicon-line',
          keepAlive: true,
        },
      },
      {
        path: 'basic/warehouseManage',
        name: 'warehouseManage',
        component: () => import('@/views/basic/warehouseManage/index'),
        meta: {
          title: '仓库列表',
          icon: 'remixicon-line',
          keepAlive: true,
        },
      },
      {
        path: 'business/fbaCondition',
        name: 'fbaCondition',
        component: () => import('@/views/business/fbaCondition/index'),
        meta: {
          title: 'FBA货件',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'business/inventoryKanban',
        name: 'inventoryKanban',
        component: () => import('@/views/business/inventoryKanban/index'),
        meta: {
          title: '库存看板',
          keepAlive: true,
        },
      },
      {
        path: 'business/salesKanban',
        name: 'SalesKanban',
        component: () => import('@/views/business/salesKanban/index'),
        meta: {
          title: '销量看板',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'plan/salesPlan',
        name: 'salesPlan',
        component: () => import('@/views/plan/salesPlan/index'),
        meta: {
          title: '销售计划',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'plan/salesPlan/planSheetDetail',
        name: 'planSheetDetail',
        component: () => import('@/views/plan/salesPlan/planSheetDetail'),
        meta: {
          title: '销售计划单',
          icon: '',
          keepAlive: false,
        },
      },
      {
        path: 'flowable/definition',
        name: 'definition',
        component: () => import('@/views/flowable/definition/index'),
        meta: {
          title: '流程定义',
          icon: '',
          keepAlive: true,
        },
      },
      // {
      //   path: 'flowable/definition/model',
      //   name: 'model',
      //   component: () => import('@/views/flowable/definition/model'),
      //   meta: {
      //     title: '流程设计',
      //     icon: '',
      //   },
      // },
      {
        path: 'flowable/task/process',
        name: 'process',
        component: () => import('@/views/flowable/task/process'),
        meta: {
          title: '我的流程',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'flowable/task/record/index',
        name: 'record',
        component: () => import('@/views/flowable/task/record/index'),
        meta: {
          title: '流程处理',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'flowable/todo',
        name: 'todo',
        component: () => import('@/views/flowable/todo/index'),
        meta: {
          title: '待办任务',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'flowable/task/finished',
        name: 'finished',
        component: () => import('@/views/flowable/task/finished/index'),
        meta: {
          title: '已办任务',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/advertKanban',
        name: 'advertKanban',
        component: () => import('@/views/ad/advertKanban/index'),
        meta: {
          title: '广告看板',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/sp_sdReports',
        name: 'sp_sdReports',
        component: () => import('@/views/ad/spAndsdReport/index'),
        meta: {
          title: '广告报表',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/sbReport',
        name: 'sbReport',
        component: () => import('@/views/ad/sbReport/index'),
        meta: {
          title: '品牌报表',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'plan/adPlan',
        name: 'adPlan',
        component: () => import('@/views/plan/adPlan'),
        meta: {
          title: '广告计划单',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'plan/adPlan/fillPlanList',
        name: 'FillPlanList',
        component: () => import('@/views/plan/adPlan/components/FillPlanList.vue'),
        meta: {
          title: '填写广告计划单',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/adPlanKanban',
        name: 'AdPlanKanban',
        component: () => import('@/views/ad/adPlanKanban'),
        meta: {
          title: '广告计划看板',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'basic/logisticsParam',
        name: 'logisticsParam',
        component: () => import('@/views/basic/logisticsParam'),
        meta: {
          title: '物流参数',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/adMerge',
        name: 'AdMerge',
        component: () => import('@/views/ad/components/search'),
        meta: {
          title: '广告搜索',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/adMergeDetail',
        name: 'AdMergeDetail',
        component: () => import('@/views/ad/adMerge/result'),
        meta: {
          title: '广告搜索详情',
          icon: '',
          keepAlive: false,
        },
      },
      {
        path: 'ad/adPutWord',
        name: 'AdPutWord',
        component: () => import('@/views/ad/components/search'),
        meta: {
          title: '广告投放',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/adPutWordDetail',
        name: 'AdPutWordDetail',
        component: () => import('@/views/ad/adPutWord/result'),
        meta: {
          title: '广告投放详情',
          icon: '',
          keepAlive: false,
        },
      },
      {
        path: 'ad/adAnalysis',
        name: 'AdAnalysis',
        component: () => import('@/views/ad/components/search'),
        meta: {
          title: '广告分析',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'ad/adAnalysisDetail',
        name: 'AdAnalysisDetail',
        component: () => import('@/views/ad/AdAnalysis/result'),
        meta: {
          title: '广告分析详情',
          icon: '',
          keepAlive: false,
        },
      },
      {
        path: 'ad/brandAdPlan',
        name: 'brandAdPlan',
        component: () => import('@/views/ad/brandAdPlan/index'),
        meta: {
          title: '品牌广告计划',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'logAndTask',
        name: 'logAndTask',
        component: () => import('@/views/log-task/index'),
        meta: {
          title: '日志任务',
          icon: '',
          keepAlive: true,
        },
      },

      {
        path: 'plan/return-notice',
        name: 'returnNotice',
        component: () => import('@/views/plan/returnNotice/index'),
        meta: {
          title: '回货通知单',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'plan/return-demand-order',
        name: 'returnDemandOrder',
        component: () => import('@/views/plan/returnDemandOrder/index'),
        meta: {
          title: '回货需求单',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'plan/receipt-record',
        name: 'receiptRecord',
        component: () => import('@/views/plan/receiptRecord/index'),
        meta: {
          title: '收货记录',
          icon: '',
          keepAlive: true,
        },
      },
      {
        path: 'plan/delivery-order',
        name: 'deliveryOrder',
        component: () => import('@/views/plan/deliveryOrder/index'),
        meta: {
          title: '送货单',
          icon: '',
          keepAlive: true,
        },
      },

      {
        path: 'system/store-auth-management',
        name: 'storeAuthManagement',
        component: () => import('@/views/system/storeAuthManagement/index'),
        meta: {
          title: '店铺权限管理',
          icon: '',
          keepAlive: true,
        },
      },

      {
        path: 'tools/store-captcha',
        name: 'storeCaptcha',
        component: () => import('@/views/tools/storeCaptcha/index'),
        meta: {
          title: '店铺验证码',
          icon: '',
          keepAlive: false,
        },
      },
      ...SYSTEM_ROUTE,
      ...SUPPLIER_ROUTE,
      ...TOOLS_ROUTE,
      ...RPA_ROUTE,
      ...LOGISTICS_ROUTE,
      ...FIRST_LEG_DELIVERY_ROUTES,
      ...MULTI_PLATFORM_ROUTES,
      ...BASE_DATA_ROUTE,
      ...PRODUCT_MANAGEMENT,
      ...OA_ROUTE,
      ...AI_ROUTE,
      ...PRODUCT_OPERATION,
    ],
  },
]
